import { actionTypeAArsrapport } from "../../actions/rapporter/aarsrapportActions";
import { CreateNewReducer } from "../../utils/reducerUtils";

const initialState = { ileggelser: [], miljogebyr: [] };
const aarsrapportReducer = (state = { ...initialState }, action) =>
  CreateNewReducer(state, action, actionTypeAArsrapport);

export default aarsrapportReducer;
